export default "__VITE_ASSET__G2Gx6xWS__"